module.exports = __webpack_public_path__ + "static/media/boxes.5a1eec13.png";